export const priceRangeMapper = ([lowerPrice, higherPrice]: [number, number | null]) => {
  return [lowerPrice, higherPrice ?? 999999];
};
